import create from 'zustand';

interface StoreState {
  desktopBottomSection: any;
  desktopRightSection: any;
  setDesktopBottomSection: (section: any) => void;
  setDesktopRightSection: (section: any) => void;
  reset: () => void;
}

const useASNMobileStore = create<StoreState>((set, get) => {


    const setDesktopBottomSection = (data: any) => {
        set({ desktopBottomSection: data });
    };

    const setDesktopRightSection = (data: any) => {
        set({ desktopRightSection: data });
    };


    return {
    setDesktopBottomSection,
    setDesktopRightSection,
    desktopBottomSection:null,
    desktopRightSection: null,
    reset: () => {
      set({ desktopBottomSection: null, desktopRightSection: null });
    }
    };
});

export default useASNMobileStore;